export const MASTER_AGENT_NAME = "Maingent";

export const STANDARD_SYSTEM_AGENT_CHAT_UI_POLICY = {
  showSystemPromptInChat: false,
  showToolCallsAndOutputsInChat: true,
  showInterAgentMessagesInChat: true,
  showWorkflowProvenanceInChat: true,
  showSchedulingActivityInChat: true,
  showSessionOperationalMetaInChat: true,
  showSupervisorControlMessagesInChat: true,
  enableHumanTakeoverMode: false,
};

export const MASTER_CHAT_UI_POLICY = {
  ...STANDARD_SYSTEM_AGENT_CHAT_UI_POLICY,
  showTaskQueuePlannerInChat: true,
};

export const MASTER_AGENT_EXAMPLE_PROMPTS = [
  {
    title: "Review today's agent work",
    prompt:
      "Show me every unfinished agent task created since 9am today, grouped by assigned agent and urgency.",
  },
  {
    title: "Check failed runs",
    prompt:
      "Find the most recent failed workflow run, explain which step failed, and summarize the data involved.",
  },
  {
    title: "Audit scheduled work",
    prompt:
      "List all scheduled agent messages and recurring agent schedules due in the next 24 hours.",
  },
  {
    title: "Find blocked sessions",
    prompt:
      "Show me agent sessions that are waiting for review, waiting for workers, or blocked by an error.",
  },
];

export const PROVISION_ERROR_MESSAGE = "Failed to provision Master Agent";
